/**
 * CaseStudyPlaceholder.jsx
 * ==============================================================================
 *
 * Werbe-Platzhalter, der gerendert wird, wenn weniger echte Case-Study-Cards
 * verfügbar sind, als das Layout schön ausfüllt (z.B. 1 echte Card → 1 Platzhalter,
 * damit das 2-Spalten-Grid nicht halb leer ist).
 *
 * Bewusst optisch deutlich abgesetzt von den echten Cards:
 *   - Weicher Gradient-Hintergrund statt Header-Gradient
 *   - Dashed Border in Primary-Blau
 *   - Genau EIN Orange-Element (CTA-Button) als Blickfang
 *
 * Wird auf der Homepage angezeigt — NICHT auf /erfolgsgeschichten
 * (dort gehören nur echte Cards hin).
 *
 * @author Claude & Christian
 * @date   2026-05-14
 */

import React from 'react';
import './CaseStudyPlaceholder.css';

/**
 * @param {Object} props
 * @param {string} [props.ctaHref='/termin/']
 * @param {string} [props.ctaLabel='15 Min. Analyse buchen']
 * @param {string} [props.title='Werden Sie unsere nächste Erfolgsgeschichte']
 * @param {string} [props.subtitle='Erste Bewertungen oft binnen Tagen — ohne Mehraufwand für Sie oder Ihr Team.']
 * @param {string} [props.footnote='Unverbindlich · 100% kostenlos']
 */
export default function CaseStudyPlaceholder({
  ctaHref = '/termin/',
  ctaLabel = '15 Min. Analyse buchen',
  title = 'Werden Sie unsere nächste Erfolgsgeschichte',
  subtitle = 'Erste Bewertungen oft binnen Tagen — ohne Mehraufwand für Sie oder Ihr Team.',
  footnote = 'Unverbindlich · 100% kostenlos'
}) {
  return (
    <div className="csc-placeholder" role="complementary" aria-label="Call-to-Action: Werden Sie unsere nächste Erfolgsgeschichte">
      <div className="csc-placeholder-icon" aria-hidden="true">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
          <polyline points="16 7 22 7 22 13" />
        </svg>
      </div>
      <div className="csc-placeholder-title">{title}</div>
      <div className="csc-placeholder-subtitle">{subtitle}</div>
      <a href={ctaHref} className="csc-placeholder-cta">
        {ctaLabel}
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </a>
      {footnote && <div className="csc-placeholder-footnote">{footnote}</div>}
    </div>
  );
}
